export default __webpack_public_path__ + "static/uniswap-abfcdf0cd86b770973dc4c56c09ecf17.png";